import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

const InputWithSelect = ({
  placeholder,
  selectValue,
  onSelectChange,
  selectOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ],
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside, true);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside, true);
    };
  }, []);

  const selectedLabel =
    selectOptions.find((option) => String(option.value) === String(selectValue))
      ?.label || placeholder;

  return (
    <div ref={dropdownRef} className="w-full relative">
      <div onClick={() => setIsOpen(!isOpen)} className=" w-full">
        <div
          className={`w-full px-4 py-3 border border-border rounded-lg 
            focus:outline-none focus:ring-1 cursor-pointer text-text-secondary focus:ring-primary text-sm 
           `}
        >
          {selectedLabel}
        </div>
        <button
          type="button"
          className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer p-1 hover:bg-gray-100 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <ChevronDown
            size={20}
            className={`text-text-secondary transition-transform ${
              isOpen ? "rotate-180" : ""
            }`}
          />
        </button>
      </div>

      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-border rounded-lg shadow-lg z-10">
          {selectOptions.map((option) => (
            <button
              key={option.value}
              onClick={() => {
                onSelectChange(String(option.value));
                setIsOpen(false);
              }}
              className={`w-full px-4 py-3 text-left text-sm cursor-pointer transition-colors first:rounded-t-lg last:rounded-b-lg ${
                String(option.value) === String(selectValue)
                  ? "bg-primary/50 text-primary-navy"
                  : "text-text-primary hover:bg-gray-50"
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default InputWithSelect;
// const InputWithSelect = ({
//   name,
//   placeholder,
//   selectName,
//   selectValue,
//   onSelectChange,
//   selectOptions = [
//     { label: "Yes", value: true },
//     { label: "No", value: false },
//   ],
//   disabled = false,
// }) => {
//   return (
//     <div className="relative w-full">
//       <input
//         type="text"
//         name={name}
//         placeholder={placeholder}
//         disabled={disabled}
//         className={`w-full px-4 py-3 pr-28 border  border-border rounded-lg
//             focus:outline-none focus:ring-1 focus:ring-primary text-sm
//             ${disabled ? "bg-gray-50 cursor-not-allowed" : "bg-white"}`}
//       />

//       <select
//         name={selectName}
//         value={selectValue}
//         onChange={(e) => {
//           onSelectChange(e.target.value);
//         }}
//         className="absolute right-1 top-1/2 -translate-y-1/2 h-10 cursor-pointer  border border-border rounded-lg px-3 text-sm focus:outline-none focus:ring-1 focus:ring-primary"
//       >
//         {selectOptions.map((option) => (
//           <option key={option?.value} value={option?.value}>
//             {option?.label}
//           </option>
//         ))}
//       </select>
//     </div>
//   );
// };

// export default InputWithSelect;
